import React, { useState, useEffect, useRef } from "react";
import ContactService from "../../../../components/contact-service";
import EmptyUsers from "../../../../components/empty-users";
import { QueryInviteList } from "../../api";
import { trackGdp } from "../../../../utils/gio-report";
import { formateDate, formateDatePile, getPrizeText } from "../../../../utils/common";
import { InviteRecord, MyInviteProps } from "../../types";
import "./index.less";

interface ContentListProps {
  isShowRank: boolean | undefined;
  activityCode?: string;
  onRemindUser: () => void;
  isReportedRef: React.MutableRefObject<boolean>;
}

const emptyText = {
  0: "暂无邀请中好友，快去邀请吧",
  1: "暂无邀请成功好友，快去邀请吧",
  2: "暂无邀请失败好友，快去邀请吧"
};

const ContentList: React.FC<MyInviteProps> = ({
  isShowRank,
  activityCode,
  onRemindUser,
  successTotal = 0,
  latestCycleSuccess = 0,
  latestCycleInfo,
  isReportedRef
}) => {
  // 内部状态管理
  const [tabStatus, setTabStatus] = useState(0);
  const [inviteListLoading, setInviteListLoading] = useState(false);
  const [inviteList, setInviteList] = useState<InviteRecord[]>([]);
  const [noticeText, setNoticeText] = useState("");

  const pageNo = useRef(1);
  const total = useRef(0);
  const isRequesting = useRef(false);
  const [prevActivityCode, setPrevActivityCode] = useState("") as any;

  // 获取邀请列表数据
  const getQueryInviteList = (isReload = false, targetStatus?: number) => {
    if (isRequesting.current) return;
    if (total.current !== 0 && inviteList.length >= total.current) return;
    if (isReload) setInviteListLoading(true);
    isRequesting.current = true;

    // 使用传入的targetStatus或当前的tabStatus
    const currentStatus = targetStatus !== undefined ? targetStatus : tabStatus;

    QueryInviteList({
      activityType: "IR",
      pageNo: pageNo.current,
      pageSize: 6,
      inviteStatus: currentStatus
    })
      .then(res => {
        console.log("QueryInviteList", res);
        if ([0, 200].includes(res.code)) {
          // 曝光埋点
          if(isReload && activityCode) {
            switch (currentStatus) {
              case 0:
                trackGdp("P20082", "B005", {
                  activityId: activityCode,
                  total_count: res.data.total
                });
                break;
              case 1:
                trackGdp("P20082", "B007", {
                  activityId: activityCode,
                  success_count: res.data.total
                });
                sessionStorage.setItem('invite_success_count', res.data.total);
                break;
              case 2:
                trackGdp("P20082", "B009", {
                  activityId: activityCode,
                  fail_count: res.data.total
                });
                break;
              default:
                break;
            }
          }

          setNoticeText(res.data.notice);
          if (!res.data?.records) {
            if (isReload) setInviteList([]);
            return;
          }

          const list = isReload
            ? res.data.records
            : inviteList.concat(res.data.records);
          setInviteList(list);
          total.current = res.data.total;
          pageNo.current += 1;

          // 更新统计数据
          if (isReload) {
            // 这里可以根据实际需要更新统计数据
            // setTotalInviteCount, setCurrentPeriodCount 等
          }
        }
      })
      .finally(() => {
        setInviteListLoading(false);
        isRequesting.current = false;
        if (isReportedRef && !isReportedRef.current && currentStatus === 0 && activityCode) {
          isReportedRef.current = true;
          const UA = navigator.userAgent || "";
          const isWXApp = /micromessenger/i.test(UA) && /miniProgram/i.test(UA);
          const isXPApp = /xiaopeng/i.test(UA);

          trackGdp("P20082", "B001", {
            activityId: activityCode,
            origin: isWXApp ? "微信充电小程序" : isXPApp ? "小鹏APP" : "其他",
            total_count: total.current,
          });
        }
      });
  };

  // 切换tab
  const handleTabChange = (status: number) => {
    if (isRequesting.current || tabStatus === status) return;
    setTabStatus(status);
    pageNo.current = 1;
    total.current = 0;
    // 直接传递新的status值给getQueryInviteList
    getQueryInviteList(true, status);
  };

  // 列表滚动加载更多
  const handleListScroll = (e) => {
    if (isRequesting.current) return;
    const { target } = e;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
      getQueryInviteList();
    }
  };

  // 初始化数据
  useEffect(() => {
    // 只有activityCode真正发生变化时才执行
    console.log('useEffect', prevActivityCode , activityCode);
    if (activityCode !== prevActivityCode) {
      setPrevActivityCode(activityCode)
    }
  }, [activityCode]);

  useEffect(() => {
    setInviteListLoading(true)
    getQueryInviteList(true);
  }, [prevActivityCode]);

  const UserInfoItem = ({ tabStatus, record }) => {
    const head = require("../../assets/default-head.svg");
    let prizeGiftText = ''
    if(tabStatus === 1) {
      if(record?.prizeStatus === 0) prizeGiftText = '奖品已经在路上啦~'
      else if(record?.prizeStatus === 2) prizeGiftText = '因活动调整，奖品无法发放，可联系客服咨询'
      else {
        const giftText = record?.prizeShowInfoList.map(item => getPrizeText(item)).join('、')
        prizeGiftText = `${!!giftText && '你已获得：'}${giftText}`
      }
    }
    return (
      <div className="list-item">
        <img className="head" src={record?.avatar || head} alt="" />
        <div className="item-info">
          {/**中间详细信息-上 */}
          <div className="phone">{record?.secretPhone || "- -"}</div>
          {/**中间详细信息-中 */}
          {tabStatus === 1 && (
            <div className="gift">{prizeGiftText}</div>
          )}
          {/**中间详细信息-下 */}
          <>
            {tabStatus === 0 && (
              <div className="time">{formateDate(record?.bindTime)}至{formateDate(record?.deadLine)}有效</div>
            )}
            {tabStatus === 1 && (
              <div className="time">{formateDatePile(record?.bindTime)}邀请</div>
            )}
            {tabStatus === 2 && <>
              {
                ['500011', '500012'].includes(record?.errReasonCode) ?
                  <ContactService>
                    {
                      record?.errReasonCode === '500011' && <div className="time">您的账号因违规操作被限制，如有疑问请<text style={{textDecoration: 'underline'}}>咨询客服</text></div>
                    }
                    {
                      record?.errReasonCode === '500012' && <div className="time">该好友账户异常，如有疑问请<text style={{textDecoration: 'underline'}}>咨询客服</text></div>
                    }
                  </ContactService>
                  :
                  <div className="time">{formateDate(record?.bindTime)}至{formateDate(record?.deadLine)}有效，该好友超时未完成订单</div>
              }
            </>}
          </>
        </div>
        {/**右侧文案 */}
        <>
          {tabStatus === 0 && (
            <div className="botton" onClick={onRemindUser}>提醒TA</div>
          )}
          {tabStatus === 1 && <div className="success">邀请成功</div>}
          {tabStatus === 2 && <div className="fail">邀请失败</div>}
        </>
      </div>
    );
  };

  const NoticeText = () => {
    if (tabStatus === 0) {
      return <div>{noticeText || "以下好友邀请中"}</div>;
    }
    if (tabStatus === 1) {
      return <div>以下好友已完成订单，你已获得奖励</div>;
    }
    if (tabStatus === 2) {
      return <div>好友超时未完成订单，可以重新邀请哦</div>;
    }
    return <></>;
  };

  const renderListContent = () => {
    return (
      <div className="my-invite-info">
        <div className="notice">
          <NoticeText />
        </div>
        {inviteListLoading ? (
          <div className="loading">
            <div className="loading-icon"></div>
          </div>
        ) : inviteList && inviteList.length !== 0 ? (
          <div className="list" onScroll={handleListScroll}>
            {inviteList.map((item, index) => (
              <UserInfoItem
                key={index}
                tabStatus={tabStatus}
                record={item}
              />
            ))}
          </div>
        ) : (
          <EmptyUsers emptyText={emptyText[tabStatus]} />
        )}
      </div>
    )
  }

  // 格式化周期时间显示 - 使用 common 中的 formatDate
  const formatCycleDate = () => {
    if (!latestCycleInfo) return "暂无周期信息";

    const startDate = formateDate(latestCycleInfo.startTime);
    const endDate = formateDate(latestCycleInfo.endTime);
    return `${startDate}-${endDate}`;
  };

  return !isShowRank ? (
    <div className="single-tab-switcher">
      <img
        className={`single-tab-switcher-icon ${tabStatus !== 0 && "disabled"}`}
        src={require("../../assets/inviting.png")}
        alt="tab-switcher-icon"
      />
      <img
        className={`single-tab-switcher-icon ${tabStatus !== 1 && "disabled"}`}
        src={require("../../assets/invite-success.png")}
        alt="tab-switcher-icon"
      />
      <img
        className={`single-tab-switcher-icon ${tabStatus !== 2 && "disabled"}`}
        src={require("../../assets/invite-fail.png")}
        alt="tab-switcher-icon"
      />
      <div className="single-tab-switcher-btn">
        <div
          className="single-tab-switcher-btn-item"
          onClick={() => handleTabChange(0)}
        />
        <div
          className="single-tab-switcher-btn-item"
          onClick={() => handleTabChange(1)}
        />
        <div
          className="single-tab-switcher-btn-item"
          onClick={() => handleTabChange(2)}
        />
      </div>
      {/* 渲染当前选中tab对应的组件内容 */}
      <div className="single-tab-content">
        {renderListContent()}
      </div>
    </div>
  ) : (
    <div className="my-invite">
      <div className="my-invite-count">
        <div className="count-item">
          <div className="count-label">邀请总数</div>
          <div className="count-number">
            {successTotal}
            <span className="unit">人</span>
          </div>
        </div>
        <div className="divider"></div>
        <div className="count-item">
          <div className="count-label">本期邀请人数</div>
          <div className="count-date">{formatCycleDate()}</div>
          <div className="count-number">
            {latestCycleSuccess}
            <span className="unit">人</span>
          </div>
        </div>
      </div>

      <div className="my-invite-list">
        <div className="my-invite-tab-btn">
          <div
            className={`my-invite-tab-btn-item ${tabStatus === 0 ? 'active' : ''}`}
            onClick={() => handleTabChange(0)}
          >邀请中</div>
          <div
            className={`my-invite-tab-btn-item ${tabStatus === 1 ? 'active' : ''}`}
            onClick={() => handleTabChange(1)}
          >邀成功</div>
          <div
            className={`my-invite-tab-btn-item ${tabStatus === 2 ? 'active' : ''}`}
            onClick={() => handleTabChange(2)}
          >邀失败</div>
        </div>
        {renderListContent()}
      </div>
    </div>
  );
};

export default ContentList;
